import { SIGNUP_ERROR_MESSAGES } from '../../constants/signUp';

export const isExistingAccountError = (error) => {
	if (!error) return false;

	const errorMessage = typeof error === 'string' ? error : error.message || '';
	return errorMessage.includes(SIGNUP_ERROR_MESSAGES.EXISTING_OPENLANE_ACCOUNT);
};

export const isEmailTakenError = (error) => {
	if (!error) return false;

	const errorMessage = typeof error === 'string' ? error : error.message || '';
	return errorMessage === SIGNUP_ERROR_MESSAGES.EMAIL_ALREADY_TAKEN;
};

export const isDuplicateEmailRedirectError = (response) => {
	if (!response || Boolean(response?.error)) return false;

	return response.duplicate_email === true && response.success === false;
};
